import { asyncRouterMap, constantRouterMap } from '../../../router/index'

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
 function hasPermission(roles, route) {
  // roles为权限身份数组
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.indexOf(role) >= 0)
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, roles) {
  // 返回满足条件的子路由对象
  const accessedRouters = asyncRouterMap.filter(route => {
    if (hasPermission(roles, route)) {
      if (route.children && route.children.length) {
        // route.children重新过滤赋值;
        route.children = filterAsyncRouter(route.children, roles)
      }
      return true // 返回该权限路由对象;
    }
    return false
  })
  return accessedRouters
}

/**
* 通过传入一个对象，使其实现深拷贝
* @param {Object} 需要传入的对象
* @returns {Object} 返回深拷贝对象
*/
function copyObj(obj = {}) { // 变量先置空
  let newobj = null;  
  //判断是否需要继续进行递归
  if (typeof (obj) == 'object' && obj !== null) {
    newobj = obj instanceof Array ? [] : {}; // 进行下一层递归克隆
    for (var i in obj) {
      newobj[i] = copyObj(obj[i])
    }                //如果不是对象直接赋值
  } else newobj = obj;            
  return newobj;    
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    roles: [],
  },
  getters: {
    permissionRouters: state => state.routers, // 所有路由
    addRouters: state => state.addRouters,  // 权限过滤路由
    roles: (state) => state.roles, // 用户权限
  },
  mutations: {
    SET_ROUTERS(state, routers) {
      let permissionRouter = [];
      permissionRouter = copyObj(constantRouterMap);

      for(let route of routers) {
        if(route.path === '/organization') {
          permissionRouter.splice(3, 0, route);
        }
        if(route.path === '/server') {
          permissionRouter.splice(5, 0, route);
        }
        if(route.path === '/system') {
          permissionRouter.splice(7, 0, route);
        }
        if(route.path === '/projectConfig') {
          permissionRouter.push(route);
        }
      }
      state.addRouters = routers // 权限路由
      state.routers = [...permissionRouter] // 总路由
    },
    SET_ROLES(state, roles) {
      state.roles = roles;
    },
  },
  actions: {
    // 根据角色，重新设置权限路由;并保存到vuex中,SET_ROUTERS;
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        let roles = data.roles;
        let accessedRouters = '';
        if (roles.indexOf('admin') >= 0) {
          // 如果是管理员，直接将权限路由赋值给新路由;
          accessedRouters = asyncRouterMap;
        } else {
          // 非管理员用户,如roles:['editor','developer']，则需要过滤权限路由数据
          accessedRouters = filterAsyncRouter(asyncRouterMap, roles);
        }
        commit('SET_ROUTERS', accessedRouters);
        resolve();
      })
    }
  }
}

export default permission;


// WEBPACK FOOTER //
// ./src/managers/vuex/modules/permission.js